"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideSheet = exports.SheetClose = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _polished = require("polished");

var _typo = require("./typo");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n        bottom: -50px;\n        right: 26px;\n        left: auto;\n        top: auto;\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        top: -50px;\n        right: 26px;\n        left: auto;\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        top: 26px;\n        right: -50px;\n        left: auto;\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    height: 30px;\n    width: 30px;\n    top: 26px;\n    left: -50px;\n    font-weight: 600;\n    transition: ", ";\n    cursor: pointer;\n    color: ", ";\n    z-index: 1000;\n    background-color: #fff;\n    border-radius: 50%;\n  \n    &:hover {\n      color: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    top: 0;\n    right: 0;\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    opacity: ", ";\n    background-color: ", ";\n    z-index: 999;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        transform: translateY(0);\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      bottom: auto;\n      top: 0;\n      width: 100vw;\n      height: auto;\n      min-height: ", ";\n      position: fixed;\n      box-shadow: 0 -3px 20px rgba(0,0,0,0.5);\n      transform: translateY(-100%);\n\n      ", "\n\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        transform: translateY(0);\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      bottom: 0;\n      top: auto;\n      width: 100vw;\n      height: auto;\n      min-height: ", ";\n      position: fixed;\n      box-shadow: 0 3px 20px rgba(0,0,0,0.5);\n      transform: translateY(100%);\n\n      ", "\n\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        transform: translateX(0);\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      top: 0;\n      left: 0;\n      box-shadow: -20px 0px 20px rgba(0,0,0,0.5); \n      transform: translateX(-100%);\n\n      ", "\n\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        transform: translateX(0);\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    right: 0;\n    height: 100vh;\n    width: ", ";\n    background-color: #fafafa;\n    z-index: 1000;\n    box-shadow: 20px 0px 20px rgba(0,0,0,0.5); \n    transform: translateX(100%);\n    transition: transform 0.3s ease-out;\n    \n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n    \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SheetBody = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-sheet-body"
})(_templateObject(), function (props) {
  return props.width;
}, function (props) {
  return props.open && (0, _styledComponents.css)(_templateObject2());
}, function (props) {
  return props.left && (0, _styledComponents.css)(_templateObject3(), function (props) {
    return props.open && (0, _styledComponents.css)(_templateObject4());
  });
}, function (props) {
  return props.bottom && (0, _styledComponents.css)(_templateObject5(), function (props) {
    return props.height;
  }, function (props) {
    return props.open && (0, _styledComponents.css)(_templateObject6());
  });
}, function (props) {
  return props.top && (0, _styledComponents.css)(_templateObject7(), function (props) {
    return props.height;
  }, function (props) {
    return props.open && (0, _styledComponents.css)(_templateObject8());
  });
});
var SheetOverlay = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-sheet-overlay"
})(_templateObject9(), function (props) {
  return props.overlayOpacity;
}, function (props) {
  return props.overlayColor;
});
var SheetClose = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-sheet-close"
})(_templateObject10(), function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return (0, _polished.transparentize)(0.6, props.theme.PrimaryFontColor);
}, function (props) {
  return (0, _polished.darken)(0.4, props.theme.PrimaryFontColor);
}, function (props) {
  return props.left && (0, _styledComponents.css)(_templateObject11());
}, function (props) {
  return props.bottom && (0, _styledComponents.css)(_templateObject12());
}, function (props) {
  return props.top && (0, _styledComponents.css)(_templateObject13());
});
exports.SheetClose = SheetClose;

var SideSheet = function SideSheet(props) {
  return /*#__PURE__*/_react["default"].createElement("div", props, props.open ? /*#__PURE__*/_react["default"].createElement(SheetOverlay, {
    onClick: props.onClose,
    overlayColor: props.overlayColor,
    overlayOpacity: props.overlayOpacity
  }) : null, /*#__PURE__*/_react["default"].createElement(SheetBody, {
    open: props.open,
    bottom: props.bottom,
    top: props.top,
    left: props.left,
    width: props.width,
    height: props.height
  }, props.open ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.closeBtn ? /*#__PURE__*/_react["default"].createElement(SheetClose, {
    onClick: props.onClose,
    bottom: props.bottom,
    top: props.top,
    left: props.left
  }, " ", /*#__PURE__*/_react["default"].createElement(_typo.Text, {
    size: "18px",
    style: {
      marginTop: '-2px'
    }
  }, "\xD7"), " ") : null) : null, props.children));
};

exports.SideSheet = SideSheet;
SideSheet.defaultProps = {
  overlayColor: "#000",
  overlayOpacity: 0.4,
  open: false,
  bottom: false,
  left: false,
  width: "40vw",
  height: "30vh",
  closeBtn: true // auto: false,

};
SideSheet.propTypes = {
  overlayColor: _propTypes["default"].string,
  overlayOpacity: _propTypes["default"].number,
  open: _propTypes["default"].bool,
  onClose: _propTypes["default"].any,
  bottom: _propTypes["default"].bool,
  left: _propTypes["default"].bool,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  closeBtn: _propTypes["default"].bool // auto: PropTypes.bool,

};